import React, { memo } from 'react'
import PropTypes from 'prop-types'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Slide } from '@mui/material'

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction={'up'} ref={ref} {...props} />
})

const Modal = memo(
  ({
    open,
    handleClose,
    children,
    title,
    buttonTitle,
    buttonVariant,
    sx,
    disableBackdropClick,
    disableEscapeKeyDown,
    hideFooter,
  }) => {
    return (
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={(event, reason) => {
          if (disableBackdropClick && reason === 'backdropClick') return
          if (handleClose) handleClose(event, reason)
        }}
        disableEscapeKeyDown={disableEscapeKeyDown}
        sx={{ ...sx }}
      >
        <DialogTitle>{title}</DialogTitle>
        <DialogContent>{children}</DialogContent>
        {!hideFooter && (
          <DialogActions>
            <Button variant={buttonVariant} onClick={handleClose}>
              {buttonTitle}
            </Button>
          </DialogActions>
        )}
      </Dialog>
    )
  },
)

Modal.defaultProps = {
  title: 'Modal Title',
  direction: 'up',
  buttonTitle: 'Close',
}

Modal.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  children: PropTypes.node,
  title: PropTypes.string,
}

export default Modal
